import React from 'react';
import './Faqs.css';
import Header from '../Header/Header';

const faqs = [
  {
    question: "How do I register on the portal?",
    answer: "You can register on the portal using your HRMS ID. Once you enter your HRMS ID, an OTP will be sent to your mobile number registered in the HRMS. After entering the details, the portal will display your employee details from HRMS. Portal will create your login once you’ll verify your details."
  },
  {
    question: "How do I login to the portal?",
    answer: "To login, enter your HRMS ID and the OTP received on your registered mobile number."
  },
  {
    question: "Is there any fee for taking the exam?",
    answer: "No, there is no fee for taking the exam."
  },
  {
    question: "How can I download my admit card?",
    answer: "Admit cards will be generated in your respective login. You can download the admit card and take the exam at the allotted center."
  },
  {
    question: "What is the exam structure for different posts?",
    answer: (
      <div>
        <p>The exam structure varies by post. Here is a summary:</p>
        <table className="exam-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Post Name</th>
              <th>Test Name</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1.</td>
              <td>Shift Attendant</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Assistant Lineman</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>Protection Assistant</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>Carrier Assistant</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>Store Assistant</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>6.</td>
              <td>Pharmacist</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>7.</td>
              <td>Lab Technician</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>8.</td>
              <td>Junior Draftsman</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>9.</td>
              <td>Technician II</td>
              <td>Computer Knowledge Test (MCQ Based)</td>
            </tr>
            <tr>
              <td>10.</td>
              <td>Assistant Law Officer</td>
              <td>Computer Knowledge Test (MCQ Based) and Type Test</td>
            </tr>
            <tr>
              <td>11.</td>
              <td>Hindi Translator</td>
              <td>Computer Knowledge Test (MCQ Based) and Type Test</td>
            </tr>
            <tr>
              <td>12.</td>
              <td>Junior Accountant</td>
              <td>Computer Knowledge Test (MCQ Based) and Type Test</td>
            </tr>
            <tr>
              <td>13.</td>
              <td>Divisional Accountant</td>
              <td>Computer Knowledge Test (MCQ Based) and Type Test</td>
            </tr>
            <tr>
              <td>14.</td>
              <td>Section Officer</td>
              <td>Computer Knowledge Test (MCQ Based) and Type Test</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  },
  {
    question: "What is the probation period for the test?",
    answer: "The test must be qualified within the probation period of two years. The two-year period begins from the date the first chance of the test is allowed, regardless of whether the employee avails the chance or not."
  },
  {
    question: "What is the scheme and pattern of the tests?",
    answer: "Refer to the instructions given by the department from time to time."
  },
  {
    question: "What happens if I fail the exam?",
    answer: "If you fail the exam, you must reapply and appear for the test(s) you did not pass in subsequent monthly exams."
  },
  {
    question: "Do I need to take both tests again if I fail one?",
    answer: "No, you only need to retake the test you did not pass. The passing of the Computer Knowledge Test (MCQ Based) and the Type Test are independent of each other."
  },
  {
    question: "How many times can I retake the exam?",
    answer: "You can retake the exam every month until you pass. There is no limit on the number of attempts within the two-year probation period."
  },
  {
    question: "Is there any fee for retaking the exam?",
    answer: "No, there is no fee for retaking the exam."
  },
  {
    question: "Do I need to register again to retake the exam?",
    answer: "No, you do not need to register again. You can retake the exam by applying online from your existing login credentials to opt for the next month's exam."
  }
];



function Faqs() {
  return (
    <div className="faqs">
      <Header/>
      <header className="faqs-header">
        <h3>Frequently Asked Questions </h3>
      </header>
      <section className="faq-section">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </section>

    </div>
  );
}

export default Faqs;
